module.exports = __webpack_public_path__ + "img/seedfirstlogo.db9ba790.png";